<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://tukhr.com" target="_blank">Tukhor</a>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://nagorik.tech">Nagorik {{new Date().getFullYear()}} </a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
